<template lang="html">
  <div class="box">
    <div class="box-header">新用户建立 1/2</div>
    <div class="box-header-avater">
      <img class="image" v-if="avatar" v-lazy="avatar" alt="">
      <img class="image" v-else src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/default-profile.png?x-oss-process=image/resize,m_fill,w_72,h_72"/>
      <div class="reload" @click="getRandomAvater">
          <img class="" src="../../assets/images/reload-white.svg" alt="">
      </div>
    </div>

    <div class="switch-box">
      <span>欢迎来到星圈！请取个昵称吧！</span>
    </div>
    <div class="form-item" tabindex="3">
      <input class="form-item-input"  type="text" name="" v-model="nickName" placeholder="请输入昵称, 32个字符以内">
    </div>
    <span @click="getRandomNickName" class="random">随机生成一个</span>

    <div class="login" :style="{background: nickName ? 'rgba(95, 184, 120, 1)' : 'rgba(229,229,234,1)'}" @click="login">
      <img src="../../assets/images/long-right.svg" alt="">
    </div>
    <Tip v-if="error" :label="errorLabel" />
  </div>
</template>

<script>
import { get, put } from '../../utils/request'
import Tip from '../../components/message.vue'
import { set, get as getItem } from '../../utils/token'
export default {
  components: {
    Tip
  },
  mounted () {
    this.getRandomAvater()
  },
  data () {
    return {
      errorLabel: '',
      error: false,
      nickName: '',
      avatar: 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/user/010.png'
    }
  },
  methods: {
    getRandomNickName () {
      const promise = get({
        url: '/user/generateNickname'
      })
      promise.then(res => {
        const { data: { nickName }, status } = res
        if (Object.is(status, 200)) {
          this.nickName = nickName
        }
      })
    },
    getRandomAvater () {
      const promise = get({
        url: '/user/chooseAvatar'
      })
      promise.then(res => {
        const { data: { avatarUrl }, status } = res
        if (Object.is(status, 200)) {
          this.avatar = avatarUrl
        }
      })
    },
    login () {
      const user = getItem('user')
      const promise = put({
        url: `/user/updateUserInfo/${user ? user.id : ''}`,
        data: {
          nickName: this.nickName,
          avatar: this.avatar,
          signName: ''
        }
      })
      promise.then(res => {
        const { message, detail } = res.data
        if (message.indexOf('用户信息更新完成') !== -1) {
          set('user', detail)
          if (!(detail.hobbys && detail.hobbys.length)) {
            this.$router.push('/exerland/hobby')
          } else {
            this.$router.push('/exerland')
          }
        } else {
          this.error = true
          this.errorLabel = message
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-popper[x-placement^=bottom] {
  z-index: 999999 !important;
}
.other-login {
  display: flex;
  justify-content: center;
  align-items: center;
  width:280px;
  height:96px;
  box-sizing: border-box;
  background:rgba(245,245,245,1);
  border-radius:8px;
  font-size: 15px;
  img {
    margin-left: 11px;
    width: 14px;
    height: 13px;
  }
}
body {
  background-color: #fff;
}
.box{
  width: 300px;
  height: 100vh;
  background: #fff;
  margin: 76px auto 37px auto;
  .box-header {
    font-size:24px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(1,170,237,1);
    line-height:33px;
    margin-bottom: 32px;
  }
  .box-header-avater {
    width:96px;
    height:96px;
    display: block;
    margin: 0 auto 32px;
    cursor: pointer;
    position: relative;
    .image {
      width:96px;
      height:96px;
    }
    .reload {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
    }
    &:hover {
      .reload {
        opacity: 1;
      }
    }
  }
  .header {
    display: flex;
    height: 41px;
    font-size: 34px;
    font-family:PingFangSC-Semibold,PingFang SC;
    font-weight:600;
    color:rgba(51,51,51,1);
    line-height: 41px;
    margin-bottom: 98px;
  }
  .desc {
    display: flex;
    height: 18px;
    font-size: 13px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(60,60,67,0.6);
    line-height: 18px;
  }
  .form-item {
    width: 300px;
    margin-top: 16px;
    height: 49px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 13px 16px;
    border-radius: 8px;
    outline:none;
    flex: 1;
    border:1px solid rgba(229,229,234,1);
    .form-item-label {
      font-size: 17px;
      font-family:SFProText-Regular,SFProText;
      font-weight:400;
      color:rgba(51,51,51,1);
    }
    .form-item-image{
      width: 6px;
      height: 6px;
      margin: 0 8px;
    }
    .form-item-input {
      // min-width: 130px;
      width: 100%;
      font-size: 17px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight: bold;
      border: none;
      outline:none;
      &::-webkit-input-placeholder {
        font-weight:400;
        color:rgba(60,60,67,0.3);
      }
    }
    &:hover {
      border-color: rgba(51, 51, 51, 1);
    }
    .form-item-prefix {
      font-size: 16px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:rgba(24,204,159,1);
      white-space: nowrap;
    }
  }
  .random {
    color: rgba(95, 184, 120, 1);
    margin-top: 20px;
    display: block;
    cursor: pointer;
  }
  .login-button{
    margin-top: 16px;
    width: 300px;
    text-align: center;
    border-radius: 8px;
    border:1px solid rgba(229,229,234,1);
    padding: 5px 0;
    font-size: 18px;
    cursor: pointer;
  }
  .switch-box {
    font-size:13px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(60,60,67,0.6);
    line-height:18px;
    margin-bottom: 16px;
  }
  .login {
    width: 88px;
    height:88px;
    border-radius: 50%;
    background:rgba(229,229,234,1);
    margin: 32px auto 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 29.86px;
      height: 29.86px;
      cursor: pointer;
    }
  }
  .footer {
    position: fixed;
    bottom: 36px;
    left: 0;
    width: 100%;
    height: 44px;
    line-height: 44px;
    text-align: center;
    font-size: 12px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(51,51,51,1);
    .bold {
      font-weight: bold;
      margin-left: 3px;
    }
  }
}
</style>
